import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline' | 'terracotta' | 'urgent';
  size?: 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wide rounded-full transition-all duration-300 transform hover:scale-[1.02]';
  const variants = {
    primary: 'bg-brand-terracotta hover:bg-brand-terracottaHover text-white shadow-cta hover:shadow-cta-hover',
    terracotta: 'bg-brand-terracotta hover:bg-brand-terracottaHover text-white shadow-cta hover:shadow-cta-hover',
    urgent: 'bg-brand-urgent hover:bg-brand-urgentHover text-white shadow-urgent animate-cta-pulse',
    outline: 'border-2 border-brand-accent text-brand-accent hover:bg-brand-accent hover:text-white bg-white'
  };
  const sizes = {
    md: 'px-6 py-3 text-base',
    lg: 'px-10 py-[18px] text-[18px]',
    xl: 'px-14 py-6 text-2xl sm:text-[26px]'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <a href={href} className={classes} data-id="element-398">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-399">
      {children}
    </button>;
}